<template>
  <div
    class="chat-container w-100 position-relative bg-white-light overflow-scroll"
    :class="{
      'bg-white': room.is_load || error != '' || room.list.length == 0,
    }"
    style="height: 100%; max-height: 100%; margin-bottom: -60px">
    <div id="hotel-room"></div>

    <!-- NORMAL HEADER -->
    <div class="bg-white w-100 fixed-top" ref="filterHeaderBlock">
      <div
        class="d-flex px-4 justify-content-between align-items-center py-3 border-b-form">
        <p class="mb-0 sub-heading-1-2 w-75">{{ getMerchant().name }}</p>
        <div class="d-flex align-items-center">
          <i
            v-if="map_list.length > 0 && iActiveHotelModuleRoom()"
            class="cursor-pointer mr-3"
            :class="view_mode == 'map' ? 'simple-icon-list' : 'simple-icon-map'"
            @click="toggleMapView(view_mode == 'map' ? 'list' : 'map')"></i>
          <div
            v-if="
              iActiveHotelModuleRoom() ||
              getMerchant().additional_appearance === 'CART'
            "
            class="d-inline-block delay position-relative"
            :class="{ 'rotate-90': popup_active == 'filter' }">
            <i
              class="simple-icon-equalizer cursor-pointer"
              @click="handlePopupFilter('filter')"></i>
            <span
              v-if="show_filter_detail"
              class="position-absolute d-block bg-orange filter-badges"></span>
          </div>
        </div>
      </div>
      <div
        v-show="scrollPosition < 100 || (scrollPosition > 100 && header_scroll)"
        class="w-100">
        <div class="ga-container fluid py-2 border-bottom" v-if="getMerchant().additional_appearance === 'SEARCH_ROOM'">
          <HotelProductTab />
        </div>

        <!-- HOTEL FILTER  -->
        <div
          v-if="
            iActiveHotelModuleRoom() ||
            getMerchant().additional_appearance === 'CART'
          "
          class="row no-gutters border-b-form"
          @click="handlePopupFilter('preview')">
          <div class="col-12 cursor-pointer border-b-form" v-if="$showCommunity()">
            <div class="py-2 px-4">
              <div class="row no-gutters">
                <div class="col-11">
                  <p class="mb-0 text-12 body-2 text-truncate">Property</p>
                  <p
                    class="mb-0 body-2-2 font-bold text-truncate position-relative">
                    <img
                      src="../../../assets/img/icon/location.png"
                      width="10"
                      class="d-inline-block mr-2 position-relative"
                      style="top: -2px" />{{ merchant_community.selected.name }}
                  </p>
                </div>
                <div class="col-1 align-self-center">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.12053 3.87295C2.26663 3.72392 2.49525 3.71037 2.65636 3.83231L2.70251 3.87295L6 7.23671L9.29749 3.87295C9.44359 3.72392 9.67221 3.71037 9.83331 3.83231L9.87947 3.87295C10.0256 4.02198 10.0388 4.25519 9.91931 4.41952L9.87947 4.4666L6.29099 8.12705C6.14489 8.27608 5.91627 8.28963 5.75517 8.1677L5.70901 8.12705L2.12053 4.4666C1.95982 4.30267 1.95982 4.03688 2.12053 3.87295Z"
                      fill="#999999" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 border-r-form cursor-pointer">
            <div class="py-2 px-4">
              <p class="mb-0 text-12 body-2 text-truncate">
                {{ $t('hotel.date.check-in') }} -
                {{ $t('hotel.date.check-out') }}
              </p>
              <p
                class="mb-0 body-2-2 font-bold text-truncate position-relative">
                <img
                  src="../../../assets/img/icon/calendar.png"
                  width="12"
                  class="d-inline-block mr-2 position-relative"
                  style="top: -2px" />{{ filter_date }}
              </p>
            </div>
          </div>
          <div class="col-4 border-r-form cursor-pointer">
            <div class="py-2 px-4">
              <p class="mb-0 text-12 body-2 text-truncate">
                {{ $t('hotel.guests.guests') }}
              </p>
              <p
                class="mb-0 body-2-2 font-bold text-truncate position-relative">
                <img
                  src="../../../assets/img/icon/guest.png"
                  width="12"
                  class="d-inline-block mr-2 position-relative"
                  style="top: -2px" />{{ filter_guest }}
              </p>
            </div>
          </div>
          <div class="col-4 cursor-pointer">
            <div class="py-2 px-4">
              <p class="mb-0 text-12 body-2 text-truncate">
                {{ $t('hotel.promo.promo-code') }}
              </p>
              <p
                class="mb-0 body-2-2 font-bold text-truncate position-relative">
                <img
                  src="../../../assets/img/icon/badge.png"
                  width="12"
                  class="d-inline-block mr-2 position-relative"
                  style="top: -2px" />{{ filter_promo }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <block
      v-if="getShowAdditionalModuleInSearch()"
      :height="
        headerBlockHeight ||
        (this.getMerchant().additional_appearance === 'SEARCH_ROOM'
          ? this.iActiveHotelModuleRoom()
            ? 176
            : 130
          : 102)
      " />
    <block v-else :height="headerBlockHeight || 102" />

    <!-- ADDITIONAL PRODUCT -->
    <template
      v-if="
        !iActiveHotelModuleRoom() &&
        getMerchant().additional_appearance === 'SEARCH_ROOM'
      ">
      <AdditionalModule />
    </template>

    <!-- ROOM LIST -->
    <template
      v-if="
        iActiveHotelModuleRoom() ||
        getMerchant().additional_appearance === 'CART'
      ">
      <!-- rooms -->
      <template>
        <div
          class="container px-2 mb-3"
          :class="{ 'pb-4': getBeCart().room_rate_details.length > 0 }">
          <div class="">
            <div class="mt-2 justify-content-center">
              <!-- Category -->
              <div class="pb-2 cursor-pointer rounded-4 mb-1">
                <div
                  class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer"
                  style="width: 20px; left: 0"
                  @click="xScroll('left', 'category_list')">
                  <img
                    src="../../../assets/img/icon/green-arrow-left.png"
                    width="18"
                    class="next-button position-relative"
                    style="left: 0; z-index: 9" />
                </div>
                <div
                  class="div-wrapper category-center d-block m-width-100 position-relative left-0-d"
                  id="category_list"
                  style="width: 88%">
                  <div class="text-center mx-auto" style="width: max-content">
                    <div
                      class="text-center bg-white mr-2 d-inline-block cursor-pointer rounded-3"
                      v-for="(data, index) in category_list"
                      @click="toggle_is_active(data.id)">
                      <p
                        class="body-2-2 px-3 mb-0 py-1 text-unactive cursor-pointer delay font-regular rounded-3"
                        :class="{
                          'border-green font-semibold text-green':
                            is_active == data.id,
                        }"
                        style="border: 1px solid #dee2e6">
                        {{ data.name }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer"
                  style="width: 20px; right: 0"
                  @click="xScroll('right', 'category_list')">
                  <img
                    src="../../../assets/img/icon/green-arrow-right.png"
                    width="18"
                    class="next-button position-absolute"
                    style="right: 0px; z-index: 9; top: -30px" />
                </div>
              </div>
              <div v-if="getBePromotionFilterId()" class="mb-3">
                <BePromotionFilterChip @clear="clearPromotionFilter" />
              </div>
              <b-skeleton-wrapper :loading="room.is_load && view_mode == 'list'">
                <template #loading>
                  <b-card body-class="p-0" class="mb-4" v-for="i in 2" :key="i">
                    <b-skeleton-img
                      no-aspect
                      width="100%"
                      height="150px"
                      card-img="top"></b-skeleton-img>
                    <b-card-body>
                      <div class="mb-2">
                        <b-skeleton width="80%" height="25px"></b-skeleton>
                      </div>
                      <b-row class="slim-grid-row">
                        <b-col cols="3">
                          <b-skeleton width="100%" height="20px"></b-skeleton>
                        </b-col>
                        <b-col cols="3">
                          <b-skeleton width="100%" height="20px"></b-skeleton>
                        </b-col>
                      </b-row>
                      <b-row class="slim-grid-row">
                        <b-col cols="3">
                          <b-skeleton width="80%" height="20px"></b-skeleton>
                        </b-col>
                        <b-col cols="3" offset="6">
                          <b-skeleton width="100%" height="20px"></b-skeleton>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </template>

                <!-- Room Type -->
                <div v-if="$isNotEmptyV2(promoCodeWarningMessage)" class="text-center container p-4 mb-2">
                  <div class="mx-auto"
                    style="max-width: 400px;"
                    @click="applyValidPromoDates">
                    <div class="p-3 filter-outer mt-3 rounded promo-suggestion-box shadow-sm w-100 mb-4" style="display: block;">
                      <div class="d-flex align-items-center mb-2 text-left">
                        <div class="icon-wrapper mr-2 flex-shrink-0 d-flex align-items-center justify-content-center">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 2H5C3.89 2 3.01 2.9 3.01 4L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V4C21 2.9 20.1 2 19 2ZM19 20H5V9H19V20ZM19 7H5V4H19V7ZM11 15H13V17H11V15ZM11 11H13V13H11V11ZM7 15H9V17H7V15ZM7 11H9V13H7V11ZM15 15H17V17H15V15ZM15 11H17V13H15V11Z" fill="currentColor"/>
                          </svg>
                        </div>
                        <p class="mb-0 text-14 font-bold promo-title mt-1">
                          {{ promoCodeErrorType === 'min_night_error' ? 'Minimum Stay Required' : 'Promo not available' }}
                        </p>
                      </div>
                      <div class="text-left w-100 mb-3">
                        <p class="mb-1 text-12 promo-desc" style="white-space: normal; line-height: 1.5;" :title="promoCodeWarningMessage">
                          {{ promoCodeWarningMessage }}
                        </p>
                        <p class="mb-0 text-12 font-medium" style="color: var(--merchant-primary-color);" v-if="promoCodeValidDates">
                          Tap to quickly adjust your dates
                        </p>
                      </div>
                      <div 
                        v-if="promoCodeValidDates"
                        class="apply-btn text-center w-100 py-2"
                      >
                        {{ promoCodeErrorType === 'min_night_error' ? 'Extend Stay' : 'Apply Dates' }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="view_mode == 'list' && room.list.length == 0 && !$isNotEmptyV2(promoCodeWarningMessage)" class="text-center container p-4 mb-2">
                  <BeMembershipPromoLoginBanner class="mb-3" @logged-in="searchClicked()" />
                  <FlexibleDateAlternatives
                    @dates-loaded="flexible_dates = $event; flexible_dates_loading = false"
                    @select-date="applyFlexibleDate" />
                  <template v-if="!flexible_dates_loading && flexible_dates.length == 0">
                    <img src="../../../assets/img/icon/404.png" width="170" />
                    <p
                      class="mb-1 mt-3 body-2-2 text-18 font-bold"
                      v-if="error != ''">
                      {{ error }}
                    </p>
                    <p
                      class="mb-1 mt-3 body-2-2 text-18 font-bold"
                      v-if="error == '' || error == undefined">
                      {{ $t('hotel.error.404') }}
                    </p>
                    <p class="mb-3 body-2-2 font-semibold">
                      {{ $t('hotel.error.404-desc') }}
                    </p>
                  </template>
                  <button
                    class="button-primary bg-white px-4 py-2 text-black mt-3"
                    @click="resetFilterSearch()">
                    {{ $t('hotel.filter.reset-filter') }}
                  </button>
                </div>
                <template v-else-if="showMapArea">
                  <div class="container px-3 py-2">
                    <BeDigitalMap
                      :maps="rootMapList"
                      :merchant-id="getMerchant().id"
                      :selected-map-id.sync="active_root_map_id"
                      :is-searching="room.is_load"
                      @select-room-type="openMapRoomType" />
                  </div>
                </template>
                <template v-else>
                  <FlexibleDateAlternatives
                    v-if="isAllRoomsSoldOut"
                    class="mb-3"
                    @dates-loaded="flexible_dates = $event; flexible_dates_loading = false"
                    @select-date="applyFlexibleDate" />
                  <PotentialPromotion
                    v-if="
                      getMerchant().search_room_is_show_promotion_highlight
                    " />
                  <template v-if="getMembershipRewardApplied().id">
                    <ClaimingReward
                      wrapper_class="mb-5"
                      title_type="inside"></ClaimingReward>
                  </template>
                  <template v-for="(room_list, rt_index) in room.list">
                    <BeRoomMobile
                      @room_type_detail="toggleRoomTypeDetail"
                      @room_rate_detail="toggleRoomRateDetail"
                      @room_rate_add="toggleRoomRateAdd"
                      @more_room="openMoreRoomInput"
                      :rt_hightlight_index="is_room_rate_highlight"
                      :roomRateHighlight="roomRateHighlight"
                      :data="room_list"
                      :type_index="rt_index"
                      :type_avlb="getRoomAvlb(room_list.id)"
                      :header_scroll="header_scroll"
                      :selected_room_rate="selected_room_rate"
                      :type="popup_active"></BeRoomMobile>
                  </template>
                </template>
              </b-skeleton-wrapper>
            </div>
          </div>
          <!-- Show More Room Type -->
          <div
            class="bg-white mt-3 pb-2"
            v-if="view_mode == 'list' && show_filter_detail && !room.is_load && room.list.length > 0">
            <div class="p-3 bg-white rounded-4 cursor-pointer border">
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="row no-gutters">
                    <div class="col-2">
                      <svg
                        width="36"
                        class="position-relative"
                        style="top: 5px"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g id="Iconly/Bold/Discount">
                          <g id="Discount">
                            <path
                              id="Discount_2"
                              class="fill-primary"
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M20.3991 9.14599L21.1193 9.86599C21.6895 10.426 21.9996 11.186 21.9996 11.986C22.0096 12.786 21.6995 13.547 21.1393 14.116C21.1327 14.1233 21.126 14.1298 21.1193 14.1362C21.116 14.1394 21.1127 14.1427 21.1093 14.146L20.3991 14.856C20.119 15.136 19.9589 15.516 19.9589 15.917V16.946C19.9589 18.606 18.6084 19.957 16.9478 19.957H15.9174C15.5173 19.957 15.1372 20.116 14.8571 20.396L14.1368 21.116C13.5466 21.707 12.7763 21.996 12.006 21.996C11.2357 21.996 10.4655 21.707 9.87525 21.127L9.14498 20.396C8.86488 20.116 8.48474 19.957 8.0846 19.957H7.05423C5.39362 19.957 4.04313 18.606 4.04313 16.946V15.917C4.04313 15.516 3.88308 15.136 3.60298 14.846L2.88271 14.136C1.71229 12.967 1.70229 11.056 2.87271 9.87699L3.60298 9.14599C3.88308 8.86599 4.04313 8.48599 4.04313 8.07599V7.05599C4.04313 5.39599 5.39362 4.04699 7.05423 4.04699H8.0846C8.48474 4.04699 8.86488 3.88599 9.14498 3.60599L9.86524 2.88599C11.0357 1.70699 12.9464 1.70699 14.1268 2.87699L14.8571 3.60599C15.1372 3.88599 15.5173 4.04699 15.9174 4.04699H16.9478C18.6084 4.04699 19.9589 5.39599 19.9589 7.05599V8.08699C19.9589 8.48599 20.119 8.86599 20.3991 9.14599ZM9.42509 15.446C9.66517 15.446 9.88525 15.356 10.0453 15.186L15.1872 10.047C15.5273 9.70699 15.5273 9.14599 15.1872 8.80599C14.8471 8.46699 14.2969 8.46699 13.9567 8.80599L8.81486 13.946C8.47474 14.286 8.47474 14.846 8.81486 15.186C8.97492 15.356 9.195 15.446 9.42509 15.446ZM13.6966 14.566C13.6966 15.056 14.0868 15.446 14.577 15.446C15.0571 15.446 15.4473 15.056 15.4473 14.566C15.4473 14.087 15.0571 13.696 14.577 13.696C14.0868 13.696 13.6966 14.087 13.6966 14.566ZM9.43509 8.55599C9.91526 8.55599 10.3054 8.94599 10.3054 9.42599C10.3054 9.91699 9.91526 10.306 9.43509 10.306C8.95492 10.306 8.55477 9.91699 8.55477 9.42599C8.55477 8.94599 8.95492 8.55599 9.43509 8.55599Z"
                              fill="#130F26" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div class="col-10" style="margin-left: -8px">
                      <p class="mb-1 font-bold text-15 text-semi-dark">
                        Want to get a bigger Promo?
                      </p>
                      <p
                        class="mb-0 font-regular text-13 font-regular text-semi-dark">
                        See our other {{ all_room.length - 1 }} rooms types for
                        promos and different types.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button
                    type="button"
                    class="ga-btn-primary-outline w-100 radius-0 text-13 py-12px rounded-4 cursor-pointer delay"
                    @click="clearFilterDetail"
                    style="background-color: #faf9f8">
                    Show All Promo
                  </button>
                </div>
              </div>
            </div>

            <!-- <button type="button" class="ga-btn-primary-outline px-5 w-100 radius-0 text-13 py-12px rounded-4 cursor-pointer delay" @click="clearFilterDetail">{{$t('hotel.room-type.show-all-room-type')}}</button> -->
          </div>
          <div
            class="height-75px"
            v-if="booking_rate != '' || cart_remove"></div>
        </div>
      </template>
      <!-- reservation -->
      <transition name="fade">
        <template v-if="popup_active == 'preview'">
          <div class="position-relative" style="z-index: 1037">
            <div class="row no-gutters justify-content-center">
              <div
                class="fixed-bottom d-table w-100 nav-bottom"
                style="top: 0px">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div
                      class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="container px-4 pb-4 pt-3 bg-white">
                        <div class="pb-3 text-center mb-2">
                          <div class="d-inline-block float-left">
                            <img
                              src="../../../assets/img/icon/close.png"
                              class="mt-1 cursor-pointer"
                              width="15"
                              @click="handlePopupFilter('close')" />
                          </div>
                          <div class="d-inline-block mx-auto text-center">
                            <p
                              class="mb-0 body-1-2 nav-hotel ml-3 mt-1 font-bold text-center">
                              {{ $t('hotel.search-rooms') }}
                            </p>
                          </div>
                          <div class="d-inline-block float-right">
                            <div class="my-1">
                              <div
                                class="d-inline-block delay"
                                :class="{ 'rotate-90': is_popup == 'filter' }">
                                <i
                                  class="simple-icon-equalizer cursor-pointer"
                                  @click="handlePopupFilter('filter')"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="px-3">
                          <div class="row">
                            <div
                              v-if="$showCommunity()"
                              class="col-12 border rounded-6 py-2 box-shadow-ota-1 mb-2 cursor-pointer"
                              @click="handlePopupFilter('merchant')">
                              <div class="row no-gutters">
                                <div class="col-11">
                                  <p
                                    class="mb-0 text-12 body-2 cursor-pointer font-regular">
                                    Property
                                  </p>
                                  <div class="position-relative">
                                    <img
                                      src="../../../assets/img/icon/location.png"
                                      width="12"
                                      class="d-inline-block align-top mr-2 position-relative"
                                      style="top: 8px" />
                                    <p
                                      class="mb-0 body-2-2 font-bold cursor-pointer d-inline-block w-75 mt-1"
                                      v-if="merchant_community.selected">
                                      {{ merchant_community.selected.name }}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-1 align-self-center">
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M2.12053 3.87295C2.26663 3.72392 2.49525 3.71037 2.65636 3.83231L2.70251 3.87295L6 7.23671L9.29749 3.87295C9.44359 3.72392 9.67221 3.71037 9.83331 3.83231L9.87947 3.87295C10.0256 4.02198 10.0388 4.25519 9.91931 4.41952L9.87947 4.4666L6.29099 8.12705C6.14489 8.27608 5.91627 8.28963 5.75517 8.1677L5.70901 8.12705L2.12053 4.4666C1.95982 4.30267 1.95982 4.03688 2.12053 3.87295Z"
                                      fill="#999999" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-12 border rounded-6 py-2 box-shadow-ota-1 mb-2"
                              @click="handlePopupFilter('date')">
                              <p
                                class="mb-0 text-12 body-2 cursor-pointer font-regular">
                                {{ $t('hotel.date.check-in') }} -
                                {{ $t('hotel.date.check-out') }}
                              </p>
                              <div class="position-relative">
                                <img
                                  src="../../../assets/img/icon/calendar.png"
                                  width="12"
                                  class="d-inline-block align-top mr-2 position-relative"
                                  style="top: 8px" />
                                <p
                                  class="mb-0 body-2-2 font-bold cursor-pointer d-inline-block w-75 mt-1">
                                  {{ filter_date }}
                                </p>
                              </div>
                            </div>
                            <div
                              class="col-12 border rounded-6 py-2 box-shadow-ota-1 mb-2"
                              @click="handlePopupFilter('guest')">
                              <p
                                class="mb-0 text-12 body-2 cursor-pointer font-regular">
                                {{ $t('hotel.guests.guests') }}
                              </p>
                              <div class="position-relative">
                                <img
                                  src="../../../assets/img/icon/guest.png"
                                  width="12"
                                  class="d-inline-block align-top mr-2 position-relative"
                                  style="top: 8px" />
                                <p
                                  class="mb-0 body-2-2 font-bold cursor-pointer mt-1 w-75 d-inline-block">
                                  {{ filter_guest }}
                                </p>
                              </div>
                            </div>
                            <div
                              class="col-12 border rounded-6 py-2 box-shadow-ota-1 mb-2"
                              @click="handlePopupFilter('promo')">
                              <p
                                class="mb-0 text-12 body-2 cursor-pointer font-regular">
                                {{ $t('hotel.promo.promo-code') }}
                              </p>
                              <div class="position-relative">
                                <img
                                  src="../../../assets/img/icon/badge.png"
                                  width="14"
                                  class="d-inline-block align-top mr-2 position-relative"
                                  style="top: 8px" />
                                <p
                                  class="mb-0 body-2-2 font-bold cursor-pointer w-75 d-inline-block position-relative">
                                  <template
                                    v-if="getBeFilter().promo_code != ''">
                                    {{ getBeFilter().promo_code }}
                                  </template>
                                  <template v-else> - </template>
                                </p>
                              </div>
                            </div>
                            <div class="col-12 pt-3 text-right">
                              <button
                                type="button"
                                class="button-secondary px-4 py-2 text-12"
                                @click="searchClicked()">
                                <img
                                  src="../../../assets/img/icon/search-white.png"
                                  class="mr-1 position-relative"
                                  style="top: -1px"
                                  width="15" />{{ $t('hotel.search') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </transition>
      <!-- filter -->
      <transition name="fade">
        <template v-if="popup_active == 'filter'">
          <BeFilterMobile @done="handlePopupFilter"> </BeFilterMobile>
        </template>
      </transition>
      <!-- pop up background -->
      <template v-if="is_popup_active">
        <transition name="fade">
          <div
            class="position-relative"
            style="z-index: 1034"
            @click="
              handlePopupFilter('close');
              show_rate_breakdown = false;
              booking_rate = false;
              cart_remove_detail = false;
            ">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" style="bottom: 0%">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div
                      class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="rounded-top-6">
                        <div
                          class="w-100 py-2 px-2"
                          style="
                            height: 100vh;
                            background-color: rgb(0 0 0 / 75%);
                          "></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </template>
      <!-- Merchant -->
      <BeSearchMobile
        :key="filter_key"
        @close="handlePopupFilter"
        @swipe="handlePopupFilter"
        @change-merchant="changeMerchant"
        v-if="popup_active == 'merchant'"
        :type="popup_active"
        :merchant_list="merchant_community.list">
      </BeSearchMobile>
      <!-- reservation date -->
      <BeSearchMobile
        :key="filter_key"
        @close="handlePopupFilter"
        @swipe="handlePopupFilter"
        v-if="popup_active == 'date'"
        :type="popup_active">
      </BeSearchMobile>
      <!-- Guest & Room-->
      <BeSearchMobile
        :key="filter_key"
        @close="handlePopupFilter"
        @swipe="handlePopupFilter"
        v-if="popup_active == 'guest'"
        :type="popup_active">
      </BeSearchMobile>
      <!-- Promo Code -->
      <BeSearchMobile
        :key="filter_key"
        @close="handlePopupFilter"
        @swipe="handlePopupFilter"
        v-if="popup_active == 'promo'"
        :type="popup_active">
      </BeSearchMobile>
      <!-- Rate Breakdown -->
      <transition name="fade">
        <template v-if="popup_active == 'room_rate'">
          <roomRateDetail
            :more_room_form="show_more_room"
            :data="selected_room_rate"
            :show-more-room-only="getMerchant().search_room_is_show_room_rate_detail"
            @close="toggleRoomRateDetail"></roomRateDetail>
        </template>
      </transition>
      <!-- room type detail-->
      <template v-if="show_room_type_detail">
        <transition name="fade">
          <roomTypeDetail
            @closeDetailRoom="toggleRoomTypeDetail()"
            :data="selected_room_type"></roomTypeDetail>
        </transition>
      </template>
      <!-- pop up background -->
      <template v-if="show_room_type_detail">
        <PopUpBackground></PopUpBackground>
      </template>
    </template>

    <!-- LOCATION & NEARBY -->
    <div class="ga-container fluid mb-3 pt-4">
      <BeLocationNearby />
    </div>

    <Footer />

    <SearchPreviewCart />

    <popupConfirmation
      stack-on-top
      :show="popupConfirmation.show"
      :title="popupConfirmation.title"
      :subtitle="popupConfirmation.subtitle"
      @hide="setConfirmationModal"
      @apply="confirmFilterChangeAction" />

    <!-- ROOM TYPE PICKED FROM THE DIGITAL MAP -->
    <BeMapRoomModalLegacy
      is-mobile
      :room-type-id="mapRoomTypeId"
      :room-type-name="mapRoomTypeName"
      :search-params="map_search_params"
      :get-room-avlb="getRoomAvlb"
      :header-scroll="header_scroll"
      :rt-hightlight-index="is_room_rate_highlight"
      :room-rate-highlight="roomRateHighlight"
      :selected-room-rate="selected_room_rate"
      :popup-active="popup_active"
      @close="closeMapRoomType"
      @select-date="applyFlexibleDate"
      @room_type_detail="toggleRoomTypeDetail"
      @room_rate_detail="toggleRoomRateDetail"
      @room_rate_add="toggleRoomRateAdd"
      @more_room="openMoreRoomInput" />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import Flickity from 'vue-flickity';
import { checkDateCheckInOutExp, isSameBeFilter } from '@/utils/index.js';
import moment from 'moment';
import { get } from '@/services/index.js';
import config from '@/config/index.js';
import VueGallerySlideshow from 'vue-gallery-slideshow';
import roomTypeDetail from '@/components/hotel/be/mobile/roomTypeDetail';
import roomRateDetail from '@/components/hotel/be/mobile/roomRateDetail';
import PopUpBackground from '@/components/hotel/be/mobile/PopUpBackground';
import BeSearchMobile from '@/components/hotel/be/BeSearchMobile';
import BeFilterMobile from '@/components/hotel/be/BeFilterMobile';
import BeRoomMobile from '@/components/hotel/be/mobile/room';
import BeDigitalMap from '@/components/hotel/be/v3/BeDigitalMap.vue';
import BeMapRoomModalLegacy from '@/components/hotel/be/v3/BeMapRoomModalLegacy.vue';
import {
  pushHistoryStep,
  releaseHistoryStep,
  abandonHistorySteps,
} from '@/utils/historyStep.js';
import { resolveDefaultViewMode } from '@/utils/beViewMode.js';
import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
import PotentialPromotion from '@/components/hotel/be/PotentialPromotion.vue';
import FlexibleDateAlternatives from '@/components/hotel/be/FlexibleDateAlternatives.vue';
import BeMembershipPromoLoginBanner from '@/components/hotel/be/BeMembershipPromoLoginBanner.vue';
import HotelProductTab from '../../../components/hotel/HotelProductTab.vue';
import AdditionalModule from '../../../components/hotel/be/AdditionalModule.vue';
import SearchPreviewCart from '../../../components/hotel/be/SearchPreviewCart.vue';
import { trackEvent } from '../../../utils/analytics';
import Footer from '@/components/hotel/Footer';
import popupConfirmation from '../../../components/general/popupConfirmation.vue';
import BeLocationNearby from '@/components/hotel/be/v3/BeLocationNearby.vue';
import BePromotionFilterChip from '@/components/hotel/be/v3/BePromotionFilterChip.vue';
import { withPromotionFilter } from '@/utils/bePromotionFilter.js';


export default {
  props: ['reload'],
  components: {
    Flickity,
    VueGallerySlideshow,
    roomTypeDetail,
    PopUpBackground,
    BeSearchMobile,
    BeFilterMobile,
    BeRoomMobile,
    roomRateDetail,
    BeLocationNearby,
    ClaimingReward,
    PotentialPromotion,
    FlexibleDateAlternatives,
    BeMembershipPromoLoginBanner,
    HotelProductTab,
    AdditionalModule,
    SearchPreviewCart,
    Footer,
    BeDigitalMap,
    BeMapRoomModalLegacy,
    popupConfirmation,
    BePromotionFilterChip
  },
  data() {
    return {
      order_policy: false,
      term_conditions: false,
      range_price: [0, 1000],
      cart_remove: false,
      booking_detail_rate: false,
      cart_remove_detail: false,
      booking_rate: '',
      lastScrollTop: 0,
      header_scroll: true,
      dateRange: {
        startDate: new Date(),
        endDate: new Date(),
      },
      search_filter: {
        date: {
          check_in: '',
          check_out: '',
        },
        guest: {},
        promo_code: '',
        price: '',
        sort_by: '',
      },
      format: 'mm/dd/yyyy',
      lastSearchedFilter: null,
      pendingConfirmAction: null,
      popupConfirmation: {
        show: false,
        title: '',
        subtitle: '',
      },
      is_tab: 'Hotel',
      is_active: 'room_type',
      filter_price: 'standar',
      language: 'indonesian',
      is_popup: '',
      is_book: 'reservation',
      is_book_date: true,
      is_book_detail: false,
      is_book_code: false,
      is_book_close: '',
      show_rate_breakdown: false,
      filter: false,
      scrollPosition: null,
      category_list: [
        {
          id: 'room_type',
          name: this.$t('hotel.rooms-type'),
        },
        {
          id: 'promotion',
          name: this.$t('hotel.promotions'),
        },
        {
          id: 'packages',
          name: this.$t('hotel.packages'),
        },
      ],
      index: null,

      // fix
      popup_active: 'date',
      room: {
        is_load: true,
        list: [],
      },
      selected_room_rate: {},
      selected_room_type: {},
      show_room_type_detail: false,
      show_more_room: false,
      error: '',
      filter_key: 1,
      merchant_community: {
        list: [],
        selected: {},
      },
      all_room: '',
      headerBlockHeight: null,
      promoCodeWarningMessage: '',
      promoCodeValidDates: null,
      promoCodeErrorType: '',
      view_mode: 'list',
      map_list: [],
      is_map_checking: true,
      active_root_map_id: null,
      map_room_type_ref: null,
      map_search_params: {},
      flexible_dates: [],
      flexible_dates_loading: true,
    };
  },
  computed: {
    isAllRoomsSoldOut() {
      if (!this.room.list || this.room.list.length == 0) return false;
      return this.room.list.every((type) =>
        type.room_rate.every(
          (rate) => !rate.bookable || this.$roomAvbl(rate.room_type.id, rate.id) <= 0
        )
      );
    },
    filter_date() {
      if (Object.keys(this.getBeFilter()).length > 0) {
        return this.$formatDateRange(
          this.getBeFilter().date.check_in,
          this.getBeFilter().date.check_out
        );
      } else {
        return (
          moment().format('DD') +
          ' - ' +
          moment().add(1, 'd').format('DD MMM YYYY')
        );
      }
    },
    filter_guest() {
      let container = [];
      if (this.getBeFilter().guest.adult > 0) {
        container.push(
          this.getBeFilter().guest.adult + ' ' + this.$t('hotel.adults.adults')
        );
      }
      if (this.getBeFilter().guest.child > 0) {
        container.push(
          this.getBeFilter().guest.child +
            ' ' +
            this.$t('hotel.children.children')
        );
      }
      if (this.getBeFilter().guest.infant > 0) {
        container.push(
          this.getBeFilter().guest.infant +
            ' ' +
            this.$t('hotel.infants.infants')
        );
      }

      let display = '';
      for (let i = 0; i < container.length; i++) {
        if (i + 1 == container.length) {
          display += container[i];
        } else {
          display += container[i] + ', ';
        }
      }

      return display;
    },
    filter_promo() {
      if (
        Object.keys(this.getBeFilter()).length > 0 &&
        this.getBeFilter().promo_code != ''
      ) {
        return this.getBeFilter().promo_code;
      } else {
        return '-';
      }
    },
    filter_sort_by() {
      return this.getBeSortBy();
    },
    is_popup_active() {
      let show = false;
      if (this.popup_active != 'close') {
        if (this.popup_active != 'done') {
          show = true;
        }
      } else if (
        this.show_rate_breakdown ||
        this.booking_rate != '' ||
        this.term_conditions ||
        this.order_policy ||
        this.cart_remove_detail
      ) {
        show = true;
      }

      return show;
    },
    total_room_cart() {
      this.getBeCart().qty.room_rate;
    },
    be_filter() {
      return this.getBeFilter();
    },
    show_filter_detail() {
      return Object.keys(this.getBeFilterDetail().data).length > 0
        ? true
        : false;
    },
    is_room_rate_highlight() {
      let rt_index = -1;
      this.room.list.forEach((item, index) => {
        let room_avlb_index = this.getBeRoomAvbl().findIndex(
          (x) => x.id == item.id
        );
        if (room_avlb_index != -1) {
          let avlb =
            this.getBeRoomAvbl()[room_avlb_index].original_availability;
          if (rt_index == -1 && avlb > 0) {
            rt_index = index;
          }
        }
      });
      return rt_index;
    },
    roomRateHighlight() {
      if (!this.room.list) return { roomTypeIndex: -1, roomRateIndex: -1 };

      let roomRateIndex = -1;
      let roomTypeIndex = this.room.list.findIndex((room) => {
        const availableRoom = this.getBeRoomAvbl().find(
          (avbl) => avbl.id === room.id
        );
        let roomRateIndexSelected = room.room_rate.findIndex(
          (roomRate) => roomRate.bookable
        );
        let validRoomType =
          availableRoom && availableRoom.original_availability > 0;
        let validRoomRate = roomRateIndexSelected != -1 && roomRateIndex == -1;
        if (validRoomType && validRoomRate) {
          roomRateIndex = roomRateIndexSelected;
          return true;
        }
      });

      return { roomTypeIndex, roomRateIndex };
    },
    selectedPromotion() {
      const promotion = this.getSelectedPromotion();
      if (!promotion) return '';
      return promotion.id;
    },
    rootMapList() {
      const roots = Array.isArray(this.map_list)
        ? this.map_list.filter((m) => m.is_root)
        : [];
      // if no map is flagged root, every map the list endpoint returns is a
      // top-level one
      return roots.length > 0 ? roots : this.map_list;
    },
    // config may default view_mode to 'map' before loadMapList confirms one
    // exists, and the map area also needs the room module active to render
    // at all (mirrors the toggle icon's own v-if guard)
    showMapArea() {
      return (
        this.view_mode == 'map' &&
        !this.is_map_checking &&
        this.iActiveHotelModuleRoom()
      );
    },
    mapRoomTypeId() {
      return this.map_room_type_ref ? this.map_room_type_ref.id : null;
    },
    mapRoomTypeName() {
      return this.map_room_type_ref ? this.map_room_type_ref.name : '';
    },
    beFilterDateSignature() {
      const { check_in, check_out } = this.getBeFilter().date;
      return `${this.$formatDateApi(check_in)}_${this.$formatDateApi(check_out)}`;
    },
  },
  watch: {
    /* An open map popup was given the params of the dates it opened on, and the
       search flow commits the new ones only after its promo-code check settles.
       Reacting to the committed dates rebuilds those params whenever they land,
       so the popup reloads the room the guest is looking at instead of holding
       stale rates. */
    beFilterDateSignature() {
      if (this.map_room_type_ref) this.map_search_params = this.getParamsRoomList(false);
    },
    filter_sort_by() {
      this.is_active = this.getBeSortBy();
    },
    total_room_cart() {
      this.pop_active =
        this.pop_active == 'cart_detail' ? 'close' : this.pop_active;
    },
    reload() {
      this.reloadAfterApplyPromo();
    },
    selectedPromotion() {
      this.loadRoomList(true);
    },
  },
  methods: {
    ...mapGetters([
      'getMerchant',
      'getBeFirstLoad',
      'getBeFilter',
      'getBeSortBy',
      'getBePrice',
      'getBeCart',
      'getBeCartRoom',
      'getBeRoomSubTotal',
      'getBaseRate',
      'getCurrentLanguage',
      'getBeFilterDetail',
      'getBeRoomAvbl',
      'getMembershipRewardApplied',
      'isNotLogin',
      'getMembershipReferral',
      'getSelectedPromotion',
      'getBePromotionFilterId',
      'iActiveHotelModuleRoom',
      'getShowAdditionalModuleInSearch',
      'getCurrentUser'
    ]),
    ...mapMutations([
      'setBeFirstLoad',
      'setBeSortBy',
      'BeManipulateRoomRate',
      'setBeFilter',
      'setBeRoomAvbl',
      'setBeFilterDetail',
      'setMembershipRewardApplied',
      'resetSelectedPromotion',
      'resetBePromotionFilter',
      'setSpecificBeFilter',
    ]),
    getRoomAvlb(room_type_id) {
      let room_avlb_index = this.getBeRoomAvbl().findIndex(
        (x) => x.id == room_type_id
      );
      let avlb = 0;
      if (room_avlb_index != -1) {
        avlb = this.getBeRoomAvbl()[room_avlb_index].original_availability;
      }
      return avlb;
    },
    toggleMapView(mode) {
      this.view_mode = mode;
    },
    loadMapList() {
      get('CORE_HOTEL', 'merchant-booking-map-list', {
        merchant_id: this.getMerchant().id,
      })
        .then((response) => {
          let res = response.data;
          if (res.success && this.$isNotEmptyV2(res.data)) {
            this.map_list = res.data;
          }
          this.reconcileViewModeAfterMapCheck();
        })
        .catch(() => {
          this.reconcileViewModeAfterMapCheck();
        });
    },
    // config may resolve to 'map' before the map-list check confirms one
    // exists; without a map there is also no toggle to escape 'map' mode, so
    // fall back once the check settles (success-but-empty, or a failed request)
    reconcileViewModeAfterMapCheck() {
      this.is_map_checking = false;
      if (this.view_mode == 'map' && this.map_list.length == 0) {
        this.view_mode = 'list';
      }
    },
    openMapRoomType(roomTypeRef) {
      this.map_search_params = this.getParamsRoomList(false);
      this.map_room_type_ref = roomTypeRef;
      this.map_room_type_step = pushHistoryStep(this.dismissMapRoomType);
    },
    /* Browser Back: its history entry is already consumed, so drop the handle
       first and let the normal close path run without rewinding again. */
    dismissMapRoomType() {
      this.map_room_type_step = null;
      this.closeMapRoomType();
    },
    closeMapRoomType() {
      if (!this.map_room_type_ref) return;
      const step = this.map_room_type_step;
      this.map_room_type_step = null;
      this.map_room_type_ref = null;
      // also rewinds past a room type detail stacked above, closing it too
      if (step) releaseHistoryStep(step);
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      this.scrollHeader();
    },
    measureFilterHeaderHeight() {
      if (this.$refs.filterHeaderBlock) {
        this.headerBlockHeight = this.$refs.filterHeaderBlock.offsetHeight;
      }
    },
    navTab(data) {
      this.is_tab = data;
      document.getElementById('hotel-room').scrollIntoView({
        behavior: 'smooth',
      });
    },
    xScroll(type, id) {
      let content = document.querySelector('#' + id);
      if (type == 'left') {
        content.scrollLeft -= 80;
      } else {
        content.scrollLeft += 80;
      }
    },
    is_Book(data, tab) {
      this.is_book = data;
      if (tab == 'book_date') {
        this.is_book_date = true;
        this.is_book_detail = false;
        this.is_book_code = false;
      } else if (tab == 'book_detail') {
        this.is_book_date = false;
        this.is_book_detail = true;
        this.is_book_code = false;
      } else if (tab == 'book_promo') {
        this.is_book_date = false;
        this.is_book_detail = false;
        this.is_book_code = true;
      }
    },
    scrollHeader() {
      let st = window.scrollY;
      if (st < this.lastScrollTop) {
        this.header_scroll = true;
      } else {
        this.header_scroll = false;
      }
      this.lastScrollTop = st;
    },
    toggle_is_active(id) {
      if (this.is_active != id) {
        this.is_active = id;
        this.setBeSortBy(this.is_active);
        document.getElementById('hotel-room').scrollIntoView({
          behavior: 'smooth',
        });
        this.loadRoomList();
      }
    },
    detailRoom() {
      this.detail_room = !this.detail_room;
    },

    // fix
    reloadAfterApplyPromo() {
      if (this.getBeFirstLoad()) {
        this.filter_key++;
      } else {
        this.getVuex();
        this.loadRoomList();
      }
    },
    handlePopupFilter(data) {
      this.popup_active = data;
      if (data == 'close') {
        this.selected_room_rate = {};
      }
      if (data == 'done') {
        this.searchClicked();
      }
    },
    loadRoomList(validateSelectedPromotion = false) {
      this.room.is_load = true;
      this.error = '';
      this.room.list = [];
      this.flexible_dates = [];
      this.flexible_dates_loading = true;
      let params = {
        merchant_id: this.getMerchant().id,
        check_in_date: moment(this.getBeFilter().date.check_in).format(
          'YYYY-MM-DD'
        ),
        check_out_date: moment(this.getBeFilter().date.check_out).format(
          'YYYY-MM-DD'
        ),
        adult: this.getBeFilter().guest.adult,
        child: this.getMerchant().search_room_is_show_filter_pax_child
          ? this.getBeFilter().guest.child
          : 0,
        infant: this.getMerchant().search_room_is_show_filter_pax_infant
          ? this.getBeFilter().guest.infant
          : 0,
        sort_by: this.getBeSortBy(),
        price_min: this.getBePrice()[0] == 0 ? '' : this.getBePrice()[0],
        price_max: this.getBePrice()[1] == 0 ? '' : this.getBePrice()[1],
        language_code: this.getCurrentLanguage(),
        device: 'MOBILE',
        use_promotion_combine: true,
      };

      if(!this.isNotLogin()){
        params.user_id = this.getCurrentUser().id
      }

      if (validateSelectedPromotion) {
        const { check_in, check_out } = this.getBeFilter().date;
        const filterStayDate = { startDate: check_in, endDate: check_out };
        const selectedPromotion = this.$getSelectedPotentialPromotion(filterStayDate);
        if (this.$isNotEmptyV2(selectedPromotion)) {
          params.promotion_affected = selectedPromotion.id;

          if(selectedPromotion.promotion_type === 'MEMBERSHIP'){
            const { id: rewardId } = selectedPromotion.membership_reward.reward;
            params.membership_reward_id = rewardId;
          }

          const { check_in, check_out } = this.getBeFilter().date;
          const newStayDate = {
            check_in_date: moment(check_in).format('YYYY-MM-DD'),
            check_out_date: moment(check_out).format('YYYY-MM-DD'),
          };
          params = Object.assign(params, newStayDate);
        }
      }

      if (this.$isNotEmptyV2(this.getMembershipReferral())) {
        params.membership_referral_code =
          this.getMembershipReferral().membership_referral_code;
        params.membership_reward_id =
          this.getMembershipReferral().membership_reward_id;
      } else if (!this.isNotLogin()) {
        if(this.$isNotEmptyV2(this.getMembershipRewardApplied().id)){
          return { membership_reward_id: this.getMembershipRewardApplied().id };
        }
      }

      if (this.show_filter_detail) {
        if (this.getBeFilterDetail().type == 'room_type') {
          params.room_type_id = this.getBeFilterDetail().data.id;
        } else {
          params.rate_id = this.getBeFilterDetail().data.id;
        }
      }
      if (this.getBeFilter().promo_code != '') {
        params.promo_code = this.getBeFilter().promo_code;
      }
      params = withPromotionFilter(params, this.getBePromotionFilterId());

      get('CORE_HOTEL', 'search-room', params).then((response) => {
        let res = response.data;
        if (res.success) {
          trackEvent ('view_item_list', {
            params: params,
            result: res.data
          })
          this.all_room = res.room_type_availability;
          this.room.list = res.data.map((x) => {
            x.room_rate = x.room_rate.map((y, y_i) => {
              let id_ori = y.id;
              y.id_ori = id_ori;
              y.id = `${id_ori}_${y_i}`;
              return y;
            });
            return x;
          });
          let add_original_availability = res.room_type_availability.map(
            (x) => {
              x.original_availability = x.availability;
              return x;
            }
          );
          this.setBeRoomAvbl(add_original_availability);
          if(this.$isNotEmptyV2(res.data) && this.$isNotEmptyV2(this.getMerchant().google_tag_manager_id)) this.sendUserGuestData(res.data[0], params)
          this.$sendEventMetaConversionsAPI('Search');
        } else {
          this.error = this.$t('hotel.error.' + res.message);
        }
        this.room.is_load = false;
      });
    },
    // Pure counterpart of loadRoomList's inline params object (no side
    // effects on room.is_load/error/flexible_dates) -- used by the map
    // quick-book popup, which searches one room_type_id at a time and must
    // not touch the page's own list-loading state.
    getParamsRoomList(validateSelectedPromotion = false) {
      let params = {
        merchant_id: this.getMerchant().id,
        check_in_date: moment(this.getBeFilter().date.check_in).format(
          'YYYY-MM-DD'
        ),
        check_out_date: moment(this.getBeFilter().date.check_out).format(
          'YYYY-MM-DD'
        ),
        adult: this.getBeFilter().guest.adult,
        child: this.getMerchant().search_room_is_show_filter_pax_child
          ? this.getBeFilter().guest.child
          : 0,
        infant: this.getMerchant().search_room_is_show_filter_pax_infant
          ? this.getBeFilter().guest.infant
          : 0,
        sort_by: this.getBeSortBy(),
        price_min: this.getBePrice()[0] == 0 ? '' : this.getBePrice()[0],
        price_max: this.getBePrice()[1] == 0 ? '' : this.getBePrice()[1],
        language_code: this.getCurrentLanguage(),
        device: 'MOBILE',
        use_promotion_combine: true,
      };

      if(!this.isNotLogin()){
        params.user_id = this.getCurrentUser().id
      }

      if (validateSelectedPromotion) {
        const { check_in, check_out } = this.getBeFilter().date;
        const filterStayDate = { startDate: check_in, endDate: check_out };
        const selectedPromotion = this.$getSelectedPotentialPromotion(filterStayDate);
        if (this.$isNotEmptyV2(selectedPromotion)) {
          params.promotion_affected = selectedPromotion.id;

          if(selectedPromotion.promotion_type === 'MEMBERSHIP'){
            const { id: rewardId } = selectedPromotion.membership_reward.reward;
            params.membership_reward_id = rewardId;
          }

          const { check_in, check_out } = this.getBeFilter().date;
          const newStayDate = {
            check_in_date: moment(check_in).format('YYYY-MM-DD'),
            check_out_date: moment(check_out).format('YYYY-MM-DD'),
          };
          params = Object.assign(params, newStayDate);
        }
      }

      if (this.$isNotEmptyV2(this.getMembershipReferral())) {
        params.membership_referral_code =
          this.getMembershipReferral().membership_referral_code;
        params.membership_reward_id =
          this.getMembershipReferral().membership_reward_id;
      } else if (!this.isNotLogin()) {
        if(this.$isNotEmptyV2(this.getMembershipRewardApplied().id)){
          return { membership_reward_id: this.getMembershipRewardApplied().id };
        }
      }

      // room_type_id is dropped here on purpose -- the map quick-book popup
      // always overrides it with the room type the guest picked. rate_id is
      // kept: it still narrows the search to the rate the guest was
      // browsing, same as loadRoomList's own params.
      if (
        this.show_filter_detail &&
        this.getBeFilterDetail().type != 'room_type'
      ) {
        params.rate_id = this.getBeFilterDetail().data.id;
      }
      if (this.getBeFilter().promo_code != '') {
        params.promo_code = this.getBeFilter().promo_code;
      }

      return withPromotionFilter(params, this.getBePromotionFilterId());
    },
    sendUserGuestData(bestRoom, filter){
      const { check_in_date: checkIn, check_out_date: checkOut, adult, child, infant } = filter;
      const bestRoomRate = bestRoom.room_rate[0];
      const params = { checkIn, checkOut, adult, child, infant,
        currency: this.getMerchant().base_currency_code,
        room: bestRoom.name,
        roomRate: bestRoomRate.name,
        bestPrice: bestRoomRate.dates.reduce((acc, value) => acc + value.final_price, 0)
      }

      this.$sendHotelUserGuestDataLayer("availability", params);
    },
    toggleRoomTypeDetail(data = '') {
      this.show_room_type_detail = !this.show_room_type_detail;
      this.selected_room_type = data == '' ? {} : data;
      this.show_more_room = false;
      if (!this.show_room_type_detail) {
        this.releaseRoomTypeDetailStep();
        return;
      }
      /* Only while stacked on the map popup: reached from the plain room list
         this modal keeps its existing Back behaviour. */
      if (this.map_room_type_ref) {
        this.room_type_detail_step = pushHistoryStep(this.dismissRoomTypeDetail);
      }
    },
    dismissRoomTypeDetail() {
      this.room_type_detail_step = null;
      this.toggleRoomTypeDetail();
    },
    releaseRoomTypeDetailStep() {
      if (!this.room_type_detail_step) return;
      const step = this.room_type_detail_step;
      this.room_type_detail_step = null;
      releaseHistoryStep(step);
    },
    toggleRoomRateDetail(data = '') {
      this.popup_active = data == '' ? 'close' : 'room_rate';
      this.selected_room_rate = data == '' ? {} : data;
      this.show_more_room = false;
    },
    toggleRoomRateAdd(data = '') {
      this.popup_active = data == '' ? 'close' : 'room_rate_add';
      this.selected_room_rate = data == '' ? {} : data;
      this.show_more_room = false;
    },
    openMoreRoomInput(data) {
      this.popup_active = 'room_rate';
      this.selected_room_rate = data.data;
      this.show_more_room = true;
    },
    resetFilterSearch(reload = true, keepPromoCode = false) {
      let newdate = new Date();
      let reset = {
        date: {
          check_in: new Date(),
          check_out: moment(newdate)
            .add(this.$defaultFilterBE('night'), 'd')
            .toDate(),
        },
        guest: {
          adult: this.$defaultFilterBE('night'),
          child: 0,
          infant: 0,
        },
        promo_code: keepPromoCode ? this.getBeFilter().promo_code : '',
      };
      const filterChanged = !isSameBeFilter(this.lastSearchedFilter, reset);
      const hasCartItems = this.getBeCartRoom().length > 0;

      const commitReset = () => {
        this.setBeFilter(reset);
        this.resetSelectedPromotion();
        if (filterChanged) this.BeManipulateRoomRate('reset');
        this.lastSearchedFilter = JSON.parse(JSON.stringify(reset));
        if (reload) location.reload();
      };

      if (filterChanged && hasCartItems) {
        this.showFilterChangeConfirm(commitReset);
        return;
      }

      commitReset();
    },
    toggleResertCart() {
      const currentFilter = this.getBeFilter();
      const filterChanged = !isSameBeFilter(this.lastSearchedFilter, currentFilter);

      if (filterChanged && this.getBeCartRoom().length > 0) {
        this.showFilterChangeConfirm(() => {
          this.BeManipulateRoomRate('reset');
          this.lastSearchedFilter = JSON.parse(JSON.stringify(currentFilter));
        });
        return;
      }

      if (filterChanged) this.BeManipulateRoomRate('reset');
      this.lastSearchedFilter = JSON.parse(JSON.stringify(currentFilter));
    },
    showFilterChangeConfirm(onConfirm) {
      this.pendingConfirmAction = onConfirm;
      this.popupConfirmation = {
        show: true,
        title: this.$t('hotel.search-filter-changed-title'),
        subtitle: this.$t('hotel.search-filter-changed-desc'),
      };
    },
    setConfirmationModal(data = { show: false, title: '', subtitle: '' }) {
      this.popupConfirmation = data;
      if (!data.show) this.pendingConfirmAction = null;
    },
    confirmFilterChangeAction() {
      this.popupConfirmation = { show: false, title: '', subtitle: '' };
      const action = this.pendingConfirmAction;
      this.pendingConfirmAction = null;
      if (action) action();
    },
    cekValidateFilterDate() {
      let today = this.$startDate();
      if (moment(this.$startDate(this.dateRange.startDate)).isBefore(today)) {
        this.dateRange.startDate = new Date();
        if (
          moment(this.$startDate(this.dateRange.endDate)).isSameOrBefore(
            this.$startDate(this.dateRange.startDate)
          )
        ) {
          this.dateRange.endDate = moment(this.dateRange.startDate)
            .add(this.$defaultFilterBE('night'), 'd')
            .toDate();
          this.cekValidateFilterDateSame();
        } else {
          this.cekValidateFilterDateSame();
        }
      }
    },
    cekValidateFilterDateSame() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        'YYYY-MM-DD'
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        'YYYY-MM-DD'
      );
      let params = {
        date: {
          check_in: this.dateRange.startDate,
          check_out: this.dateRange.endDate,
        },
        guest: {
          adult: this.getBeFilter().guest.adult,
          child: this.getBeFilter().guest.child,
          infant: this.getBeFilter().guest.infant,
        },
        promo_code: this.getBeFilter().promo_code,
      };
      this.setBeFilter(params);
    },
    getVuex() {
      let copied = JSON.parse(JSON.stringify(this.getBeFilter()));
      this.dateRange = {
        startDate: copied.date.check_in,
        endDate: copied.date.check_out,
      };
      this.cekValidateFilterDate();
    },
    loadMerchantList() {
      return new Promise((success, fail) => {
        get('COMMUNITY', 'merchant-list', {
          community_id: this.getMerchant().community.id,
          merchant_type: 'hotel',
        }).then((response) => {
          let res = response.data;
          if (res.success) {
            this.merchant_community.list = res.data;
            this.merchant_community.list.unshift({
              name: 'All Property',
              id: 'all',
            });
            this.merchant_community.selected = res.data.find(
              (x) => x.id == this.getMerchant().id
            );
            success();
          } else {
            fail(res.message);
          }
        });
      });
    },
    async searchClicked({ dropInvalidPromoCode = false } = {}) {
      if (
        !this.$showCommunity() ||
        this.merchant_community.selected.id == this.getMerchant().id
      ) {
        this.promoCodeWarningMessage = '';
        this.promoCodeValidDates = null;
        this.promoCodeErrorType = '';

        if (this.getBeFilter().promo_code != '') {
          this.setMembershipRewardApplied({});

          const dateRange = await this.checkingPromoCode().catch((error) => {
            if (!dropInvalidPromoCode) throw error;
            this.setSpecificBeFilter([{ key: 'promo_code', value: '' }]);
            return null;
          });
          if (dateRange) {
            if (dateRange.min_night_error) {
              this.promoCodeErrorType = 'min_night_error';
              this.promoCodeWarningMessage = `Minimum stay for this promo code is ${dateRange.min_night} night(s). You selected ${dateRange.total_nights} night(s).`;
              this.promoCodeValidDates = dateRange.startDate && dateRange.endDate ? { startDate: dateRange.startDate, endDate: dateRange.endDate } : null;
            } else {
              this.promoCodeErrorType = 'date_not_available';
              let availableDatesText = '';
              if (dateRange.stay_date && dateRange.stay_date.length > 0) {
                availableDatesText = dateRange.stay_date.map(d => `${moment(d.start_date, 'YYYY-MM-DD').format('DD MMM YYYY')} - ${moment(d.end_date, 'YYYY-MM-DD').format('DD MMM YYYY')}`).join(', ');
              } else {
                availableDatesText = `${moment(dateRange.startDate).format('DD MMM YYYY')} - ${moment(dateRange.endDate).format('DD MMM YYYY')}`;
              }
              this.promoCodeWarningMessage = `${availableDatesText}`;
              this.promoCodeValidDates = { startDate: dateRange.startDate, endDate: dateRange.endDate };
            }
          }
        }
        trackEvent('search_room', this.getBeFilter());
        this.toggleResertCart();
        this.loadRoomList();
        if (this.getBeFirstLoad()) {
          this.setBeFirstLoad(false);
        }
        this.$trackRoomSearch();
        this.popup_active = 'done';
      } else {
        if (this.merchant_community.selected.id == 'all') {
          this.goToGroup();
        } else {
          let params = `hotel-filter-redirect/${
            this.getBeFilter().date.check_in
          }/${this.getBeFilter().date.check_out}`;
          if (this.getBeFilter().promo_code != '') {
            params += `/${this.getBeFilter().promo_code}`;
          } else {
            params += '/promo_code_empty';
          }
          params += `?guest=${this.getBeFilter().guest.adult}-${
            this.getBeFilter().guest.child
          }-${this.getBeFilter().guest.infant}`;
          let merchant_url = `${window.location.origin}/${this.merchant_community.selected.code}/${params}`;
          window.open(merchant_url, '_self');
        }
      }
    },
    goToGroup() {
      let community_url = `${window.location.origin}/${
        this.getMerchant().community.code
      }/group`;
      window.open(community_url, '_self');
    },
    changeMerchant(merchant) {
      this.merchant_community.selected = this.merchant_community.list.find(
        (x) => x.id == merchant
      );
      this.searchClicked();
    },
    clearFilterDetail() {
      let params = {
        type: 'room_type',
        data: {},
      };
      this.setBeFilterDetail(params);
      this.loadRoomList();
    },
    clearPromotionFilter() {
      this.resetBePromotionFilter();
      this.closeMapRoomType();
      this.loadRoomList();
    },
    resetSavedReward() {
      this.setMembershipRewardApplied({});
      this.searchClicked();
    },
    async checkingPromoCode() {
      try {
        const apiParams = {
          merchant_id: this.getMerchant().id,
          promo_code: this.getBeFilter().promo_code,
        };

        const apiResponse = await get(
          'CORE_HOTEL',
          'promocode-detail',
          apiParams
        );
        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);

        if (data) {
          if(data.stay_date && data.stay_date.length > 0){
            let availableDates = [];
            const today = moment().startOf('day');

            data.stay_date.forEach(stay => {
              let current = moment(stay.start_date, 'YYYY-MM-DD').startOf('day');
              let end = moment(stay.end_date, 'YYYY-MM-DD').startOf('day');

              if (current.isBefore(today)) current = today.clone();

              while (current.isSameOrBefore(end)) {
                const dayMap = [
                  'stay_sunday',
                  'stay_monday',
                  'stay_tuesday',
                  'stay_wednesday',
                  'stay_thursday',
                  'stay_friday',
                  'stay_saturday'
                ];
                const dayName = dayMap[current.day()];

                const isDayValid = stay[dayName] !== false && stay[dayName] !== 0;

                if (isDayValid) {
                  const minNight = data.min_night || 1;
                  availableDates.push({ date: current.clone(), minNight });
                }
                current.add(1, 'day');
              }
            });

            if (availableDates.length > 0) {
              const currentCheckIn = moment(this.getBeFilter().date.check_in).startOf('day');
              const currentCheckOut = moment(this.getBeFilter().date.check_out).startOf('day');

              const availableDateStrings = availableDates.map(o => o.date.format('YYYY-MM-DD'));

              const globalMinNight = data.min_night || 1;

              const isRangeAvailable = (start, lengthNights) => {
                if (lengthNights <= 0) return false;
                let temp = start.clone();
                for (let i = 0; i < lengthNights; i++) {
                  if (!availableDateStrings.includes(temp.format('YYYY-MM-DD'))) return false;
                  temp.add(1, 'day');
                }
                return true;
              };

              availableDates.sort((a, b) => a.date.valueOf() - b.date.valueOf());
              let fallbackCheckIn = availableDates[0].date.clone();
              let fallbackCheckOut = fallbackCheckIn.clone().add(globalMinNight, 'days');

              for (let i = 0; i < availableDates.length; i++) {
                const candidate = availableDates[i].date;
                if (isRangeAvailable(candidate, globalMinNight)) {
                  fallbackCheckIn = candidate.clone();
                  fallbackCheckOut = candidate.clone().add(globalMinNight, 'days');
                  break;
                }
              }

              const currentNights = currentCheckOut.diff(currentCheckIn, 'days');
              const isCurrentDateValid = isRangeAvailable(currentCheckIn, currentNights);

              if (isCurrentDateValid) {
                if (currentNights < globalMinNight) {
                  const newCheckOut = currentCheckIn.clone().add(globalMinNight, 'days');

                  if (isRangeAvailable(currentCheckIn, globalMinNight)) {
                    return {
                      startDate: currentCheckIn.toDate(),
                      endDate: newCheckOut.toDate(),
                      stay_date: data.stay_date,
                      min_night_error: true,
                      min_night: globalMinNight,
                      total_nights: currentNights
                    };
                  } else {
                    return {
                      startDate: fallbackCheckIn.toDate(),
                      endDate: fallbackCheckOut.toDate(),
                      stay_date: data.stay_date
                    };
                  }
                } else {
                  return null;
                }
              } else {
                return {
                  startDate: fallbackCheckIn.toDate(),
                  endDate: fallbackCheckOut.toDate(),
                  stay_date: data.stay_date
                };
              }
            }
          }

          // Validasi: jika total malam yang dipilih kurang dari minimum night promo code
          const globalMinNight = data.min_night || 1;
          const currentCheckIn = moment(this.getBeFilter().date.check_in).startOf('day');
          const currentCheckOut = moment(this.getBeFilter().date.check_out).startOf('day');
          const totalNights = currentCheckOut.diff(currentCheckIn, 'days');

          if (totalNights < globalMinNight) {
            return {
              min_night_error: true,
              min_night: globalMinNight,
              total_nights: totalNights,
              startDate: currentCheckIn.toDate(),
              endDate: moment(currentCheckIn).add(globalMinNight, 'days').toDate(),
            };
          }
        }

        return null;
      } catch (error) {
        console.log('ERROR in checkingPromoCode() RoomMobile: ', error.message);
        throw error;
      }
    },
    applyValidPromoDates() {
      if (this.promoCodeValidDates) {
        let params = { ...this.getBeFilter() };
        params.date = {
          check_in: this.promoCodeValidDates.startDate,
          check_out: this.promoCodeValidDates.endDate,
        };
        this.setBeFilter(params);
        this.getVuex();
        this.searchClicked();
      }
    },
    applyFlexibleDate({ check_in_date, check_out_date }) {
      let params = { ...this.getBeFilter() };
      params.date = { check_in: check_in_date, check_out: check_out_date };
      this.setBeFilter(params);
      this.getVuex();
      // a wrong code carried in from the website plugin would fail the suggested dates too
      this.searchClicked({ dropInvalidPromoCode: true });
    },
  },
  mounted() {
    if (this.$showCommunity()) {
      this.loadMerchantList();
    }
    this.loadMapList();
    this.lastSearchedFilter = JSON.parse(JSON.stringify(this.getBeFilter()));
    this.getVuex();
    window.addEventListener('scroll', this.updateScroll);
    document.getElementById('hotel-room').scrollIntoView({
      behavior: 'smooth',
    });
    if (!this.getBeFirstLoad()) {
      checkDateCheckInOutExp();
      this.loadRoomList();
    } else {
      // first load only opens the date popup -- no search runs yet, so the
      // initial loading state must be released or the map overlay never clears
      this.room.is_load = false;
    }
    this.$nextTick(() => {
      this.measureFilterHeaderHeight();
      if (window.ResizeObserver && this.$refs.filterHeaderBlock) {
        this.headerResizeObserver = new ResizeObserver(
          this.measureFilterHeaderHeight
        );
        this.headerResizeObserver.observe(this.$refs.filterHeaderBlock);
      }
    });
  },
  beforeDestroy() {
    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
    }
    abandonHistorySteps();
  },
  created() {
    /* Plain instance properties: a handle on the browser entry that mirrors an
       open layer is bookkeeping, not view state. */
    this.map_room_type_step = null;
    this.room_type_detail_step = null;
    this.view_mode = resolveDefaultViewMode(this.getMerchant());
    this.$validateActiveReward('HOTEL_PROMOTION');
    if (this.getBeFirstLoad()) {
      this.resetFilterSearch(false, true);
      this.popup_active = 'date';
    } else {
      this.popup_active = 'close';
    }
    this.is_active = this.getBeSortBy();
  },
};
</script>

<style scoped>
@media screen and (max-width: 655px) {
  .mobile-none {
    display: none !important;
  }
}

@media screen and (min-width: 655px) {
  .category-center {
    margin-right: auto;
    margin-left: auto;
  }
}

@media screen and (min-width: 993px) {
  .category-center {
    margin-right: 0;
    margin-left: 0;
  }
}

.top-rate {
  top: 120px !important;
}

.rooms-guest:after,
.rooms-guest:before {
  position: absolute;
  display: inline-block;
  content: '';
  top: -6px;
  left: 56px;
}

.rooms-guest:after {
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  border-left: 7px solid transparent;
}

.rooms-guest:before {
  top: -7px;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 7px solid #ccc;
}

.h-100vh {
  height: 100vh !important;
}

.filter-badges {
  height: 15px;
  width: 15px;
  border-radius: 8px;
  top: -5px;
  right: -5px;
}
</style>
<style>
.promo-suggestion-box {
  background: #FFF9F3;
  border: 1px solid #EEDCCB;
  border-left: 4px solid var(--merchant-primary-color);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: block;
}
.promo-suggestion-box:hover {
  background: #FFF4E8;
  border-color: #DAB99C;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(167, 122, 85, 0.12) !important;
}
.promo-suggestion-box .icon-wrapper {
  color: var(--merchant-primary-color);
  background: white;
  padding: 10px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(167, 122, 85, 0.1);
}
.promo-suggestion-box .promo-title {
  color: #5D4037;
  letter-spacing: -0.01em;
}
.promo-suggestion-box .promo-desc {
  color: #795548;
  line-height: 1.5;
}
.promo-suggestion-box .apply-btn {
  background-color: var(--merchant-primary-color);
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(167, 122, 85, 0.2);
}
.promo-suggestion-box:hover .apply-btn {
  background-color: #8C613D;
  transform: scale(1.02);
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/RoomMobile.vue